import { ThemeProvider as NextThemeProvider, ThemeProviderProps } from 'next-themes'
import { type FC, memo } from 'react'

export const ThemeProvider: FC<ThemeProviderProps> = memo(({ children, ...props }) => {
  return <NextThemeProvider {...props}>{children}</NextThemeProvider>
})
